// extracted by mini-css-extract-plugin
export var drawerPaper = "_3b-0";
export var itemImage = "_3b-1";